import { Event } from '@sentry/vue'

/**
 * Filters out errors from custom JavaScript functions like postscribe and runScript
 * This prevents errors from injected custom scripts from cluttering Sentry
 */
export const filterCustomJsErrors = (event: Event): boolean => {
  try {
    if (event.exception?.values?.[0]?.stacktrace?.frames) {
      const frames = event.exception.values[0].stacktrace.frames;
      const hasCustomJsFrame = frames.some(frame =>
        ( frame.function?.includes("runScript") ||
        frame.function?.includes("postscribe") )
      );

      if (hasCustomJsFrame) {
        console.log("[SENTRY_DEBUG] Filtering custom JS error:", frames);
        return true;
      }
    }

    // You can also check by message if stacktrace is missing:
    if (event.exception?.values?.[0]?.value?.includes("postscribe")) {
      console.log("[SENTRY_DEBUG] Filtering error by message");
      return true;
    }
  } catch (e) {
    console.warn("[SENTRY_DEBUG] filterCustomJsErrors failed", e);
  }

  return false;
};